import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types'
import Select from 'react-select';
import { useIntl } from 'react-intl'

function BusinessCategorySelect({ id, value, onChange, placeholder, allowEmpty, options }) {
    const intl = useIntl()
    const [selected, setSelected] = useState(null)

    useEffect(() => {
        setSelected(options?.find(o => value === o.id) ?? null)
    }, [value])

    const handleChange = option => {
        if (allowEmpty && selected?.id === option.id) {
            onChange(null)
            return
        }
        onChange(option.id)
    }

    return (
        <Select
            inputId={id}
            className='react-select-container'
            classNamePrefix='react-select'
            loadingMessage={() => intl.formatMessage({ id: "forms.select.loading" })}
            noOptionsMessage={() => intl.formatMessage({ id: "forms.select.no-options" })}
            getOptionLabel={option => option.label}
            getOptionValue={option => option.id}
            value={selected}
            options={options}
            openMenuOnFocus={true}
            placeholder={placeholder ?? intl.formatMessage({ id: "forms.remote.placeholder" })}
            onChange={handleChange}
            menuPortalTarget={document.getElementById('business-categories-options-menu')}
            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
        />
    )
}

BusinessCategorySelect.defaultProps = {
    onChange: () => {
    },
    allowEmpty: false,
}

BusinessCategorySelect.propTypes = {
    id: PropTypes.string,
    value: PropTypes.number,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    allowEmpty: PropTypes.bool,
}

export default BusinessCategorySelect;
